import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.21967 8.71967C4.92678 9.01256 4.92678 9.48744 5.21967 9.78033L11.4697 16.0303C11.7626 16.3232 12.2374 16.3232 12.5303 16.0303L18.7803 9.78033C19.0732 9.48744 19.0732 9.01256 18.7803 8.71967C18.4874 8.42678 18.0126 8.42678 17.7197 8.71967L12 14.4393L6.28033 8.71967C5.98744 8.42678 5.51256 8.42678 5.21967 8.71967Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgChevronDown;
